import { call, put, takeEvery } from 'redux-saga/effects';
import {
    updateEnrolledDeviceFailure,
    updateEnrolledDeviceRequest,
    updateEnrolledDeviceSuccess
} from './UpdateUserEnrolledDeviceDetailsSlice';
import i18next from 'i18next';
import { _API_ENDPOINT, SUCCESS } from '../../constants/AppConstants';
import { _CALLPUTAPI } from '../../api/apiHandler';
import UpdateUserEnrolledDevicePayload from '../../utils/MyDevices/UpdateUserEnrolledDevicePayload';

function _UPDATE_ENROLLED_DEVICE(payload) {
    const endpoint =_API_ENDPOINT.UPDATE_ENROLLED_DEVICE;
    return _CALLPUTAPI(endpoint, payload)
        .then(response => response)
        .catch(error => { throw error; });
}

function* updateUserEnrolledDeviceSaga(action) {
    try {
        const updateUserEnrolledDeviceDetailsPayload = UpdateUserEnrolledDevicePayload(action.payload);

        const response = yield call(_UPDATE_ENROLLED_DEVICE, updateUserEnrolledDeviceDetailsPayload);

        if (response?.actionStatus?.toUpperCase() === SUCCESS) {
            yield put(updateEnrolledDeviceSuccess(response));
        } else {
            yield put(updateEnrolledDeviceFailure({
                message: i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
            }));
        }
    } catch (error) {
        yield put(updateEnrolledDeviceFailure({ message: error?.message || "Unknown error" }));
    }
}

export default function* watchUpdateUserEnrolledDevice() {
    yield takeEvery(updateEnrolledDeviceRequest.type, updateUserEnrolledDeviceSaga);
}
